import api from '../../../api';

export const WorkflowGetList = holdingID => api.get('Workflow/List', {
  params: { holdingID },
}).then(response => response.data.return);

export const WorkflowDelete = workflowid => api.get('Workflow/Delete', {
  params: { workflowid },
}).then(response => response.data.return);

export const WorkflowGetListIncomplete = holdingID => api.get('Workflow/List/incomplete', {
  params: { holdingID },
}).then(response => response.data.return);

export const WorkflowCreate = params => api.post('Workflow/Create', {
  RequestWrapper: {
    CompanyId: params.CompanyId,
    Name: params.Name,
  },
}).then(response => response.data);


// WEBPACK FOOTER //
// ./src/redux/actions/tracker/workflowActions.js